import { useState } from 'react';

import { Button, Dialog } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import { useToast } from '../../../../lib/toast';
import { useSuaNguon } from '../../hooks/useNguon';
import { useMoTaLoi } from '../../hooks/useMoTaLoi';
import { laUrlApi } from '../../nghiep-vu/ket-noi';
import type { GraphqlSource } from '../../types';
import { CacOKetNoiApi, khoiApi, tuKetNoi, type KhaiApi } from './CacOKetNoiApi';

/**
 * Sửa kết nối của một nguồn API: địa chỉ gốc, xác thực, khoá, thời gian chờ (port `SuaKetNoiApi.tsx` native).
 *
 * Khoá là chỉ-ghi — máy chủ không bao giờ trả ra — nên ô khoá luôn mở ra TRỐNG, để trống là giữ khoá cũ. Đổi sang "Không
 * cần khoá" thì xoá khoá đã lưu (`apiSecret: ''`), để một khoá không còn dùng không nằm lại trong kho bí mật.
 */
export function SuaKetNoiApi({ nguon, onClose }: { nguon: GraphqlSource | null; onClose: () => void }) {
  return nguon ? <HopSua key={nguon.id} nguon={nguon} onClose={onClose} /> : null;
}

function HopSua({ nguon, onClose }: { nguon: GraphqlSource; onClose: () => void }) {
  const { t } = useT();
  const toast = useToast();
  const moTaLoi = useMoTaLoi();
  const sua = useSuaNguon();
  // Khởi tạo một lần từ nguồn đang sửa — `key` theo id nên đổi nguồn là dựng lại hộp.
  const [gt, setGt] = useState<KhaiApi>(() => tuKetNoi(nguon.api));
  const dat = (thay: Partial<KhaiApi>) => setGt((p) => ({ ...p, ...thay }));

  const luu = () =>
    sua.mutate(
      {
        id: nguon.id,
        du: {
          api: khoiApi(gt),
          ...(gt.xacThuc === 'none' ? { apiSecret: '' } : gt.khoaApi ? { apiSecret: gt.khoaApi } : {}),
        },
      },
      {
        onSuccess: () => {
          toast.success(t('troLyAiKetNoiThem.daLuuKetNoiApi'));
          onClose();
        },
      },
    );

  return (
    <Dialog open onClose={onClose} width={640} title={t('troLyAiKetNoiThem.suaKetNoiApi')}>
      <div className="space-y-3 pt-2">
        <CacOKetNoiApi gt={gt} dat={dat} giuKhoa />
        {sua.error ? (
          <p role="alert" className="rounded border border-danger-100 bg-danger-50 p-3 text-sm text-danger-700">
            {moTaLoi(sua.error)}
          </p>
        ) : null}
      </div>
      <div className="mt-4 flex flex-wrap justify-end gap-2">
        <Button variant="outline" onClick={onClose}>
          {t('chung.huy')}
        </Button>
        <Button loading={sua.isPending} disabled={!laUrlApi(gt.apiUrl)} onClick={luu}>
          {t('troLyAiKetNoiThem.luuKetNoiApi')}
        </Button>
      </div>
    </Dialog>
  );
}
